<template>
    <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
    name: 'master-warehouseSet',
    components: {
        PageTable,
    },
}
</script>
